import { useContext, useState } from "react";
import {
  forgetPassword,
  GetForApproval,
  updateForApproval,
} from "../api/FetchAPI";
import {
  ForApprovalInfo,
  SecurityQuestionRequestArray,
} from "../lib/interfaces/index";
import { AuthContext } from "../components/AuthContextComponent";
import {
  confirmationMsg,
  generateLoading,
  showAlert,
  stopLoading,
} from "../promptMessages/PromptMessages";
import { ALERTMSG } from "../lib/enums/index";
import { noDataFound } from "../lib/constants/placeholder/Placeholder";
import useUserLogin from "./UserLoginhook";
import { FetchErr } from "../lib/helpers/UnhandledError";
import useHeadComponent from "./HeaderHook";
import useManualUpload from "./ManualUploadhook";
import { handleHttpError } from "../lib/helpers/HanldeHttpError";

const useApprove = () => {
  const { username, userInfo } = useContext(AuthContext);
  const { customColor } = useUserLogin();
  const [noData, setNoData] = useState("");
  const [loading, setLoading] = useState(true);
  const [redirectModal, setRedirectModal] = useState(false);
  const [currentQuestions, setCurrentQuestions] =
    useState<SecurityQuestionRequestArray | null>(null);

  const [forApproval, setForApproval] = useState<ForApprovalInfo | null>(null);
  const { selectedPartner } = useManualUpload();
  const { partnerBalance } = useHeadComponent(selectedPartner);

  const [isRejectModalVisible, setIsRejectModalVisible] = useState(false);
  const [batchNumber, setBatchNumber] = useState();

  const themeBackground = userInfo?.theme === "DARK" ? "#24292e" : "";
  const themeTextColor = userInfo?.theme === "DARK" ? "#fafbfc" : "";
  let request = {
    userId: username,
    partnersId: userInfo?.partnersId || 0,
  };

  //Handle to Get All Batch for Approval
  const handleGetForApproval = async () => {
    try {
      const response: any = await GetForApproval(request);
      const { respCode, respMsg } = response;
      if (respCode === 2000) {
        setForApproval(response);
      } else if (respCode === 3141) {
        setForApproval(null);
        setNoData(noDataFound);
      } else {
        showAlert(
          ALERTMSG.SOMEWENTWRONG,
          respMsg,
          "error",
          customColor,
          themeBackground,
          themeTextColor
        );
      }
    } catch (error: any) {
      //For Unhandled Error
      // FetchErr(error, themeBackground, customColor, themeTextColor);
      handleHttpError(error, customColor);
    }
  };

  const handleRejectChange = async (batchNumber: any) => {
    generateLoading("Please Wait", themeBackground, themeTextColor);
    setTimeout(() => {
      setBatchNumber(batchNumber);
      stopLoading();
      setIsRejectModalVisible(true); // Show the modal
    }, 1000);
  };

  const handleReasonSubmit = () => {
    generateLoading("Please wait..");
    setTimeout(() => {
      stopLoading();
    }, 1000);
  };

  const handleReason = (toggle: boolean = true) => {
    if (!toggle) {
      setIsRejectModalVisible(false);
      return;
    }
  };

  const handleUpdateForApproval = async (batchNumber: any) => {
    let requestApproval = {
      userId: username,
      partnersId: userInfo?.partnersId || 0,
      batchNumber: batchNumber,
    };

    const confirmed = await confirmationMsg(
      "Are you sure to approve this transactions?",
      "",
      "",
      "",
      customColor
    );

    if (confirmed) {
      generateLoading("Please Wait");

      const response: any = await updateForApproval(requestApproval);

      const { respCode, respMsg } = response;

      if (respCode === 2000) {
        stopLoading();

        handleGetForApproval();
        partnerBalance();

        showAlert(
          ALERTMSG.APPROVED,
          "Batch approved successfully! ",
          "success",
          customColor,
          themeBackground,
          themeTextColor
        );
      } else if (respCode === 3141) {
        stopLoading();
        return;
      } else {
        stopLoading();

        showAlert(
          ALERTMSG.ERR,
          respMsg,
          "error",
          customColor,
          themeBackground,
          themeTextColor
        );
      }
    }
  };

  const fetchCurrentUserQuestion = async () => {
    const response: any = await forgetPassword(username);

    const { respCode, respMsg, questionInfo } = response;

    if (respCode === 2000) {
      if (questionInfo === null || questionInfo < 2) {
        setCurrentQuestions(null);

        setRedirectModal(true);
      } else {
        setRedirectModal(false);
        setCurrentQuestions(questionInfo);
      }
    } else {
      showAlert(
        ALERTMSG.SOMEWENTWRONG,
        `${respMsg} (${respCode})`,
        "error",
        customColor,
        themeBackground,
        themeTextColor
      );
    }
  };

  return {
    batchNumber,
    forApproval,
    isRejectModalVisible,
    loading,
    noData,
    redirectModal,
    fetchCurrentUserQuestion,
    handleGetForApproval,
    handleRejectChange,
    handleReason,
    handleReasonSubmit,
    handleUpdateForApproval,
    setLoading,
    setIsRejectModalVisible,
  };
};

export default useApprove;
